// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import $ from "jquery";
import Rolldate from "packs/rolldate.js"
import "channels"
import consumer from "channels/consumer"
import 'datatables.net-dt'

require("packs/jquery-ui.min.js");
// require("packs/jquery.ui.touch-punch.min.js");
require("packs/bootstrap.bundle.js");
require("packs/jquery.inputmask.bundle.js")
require("packs/jq-signature.js")
// for buttons datatable
require("packs/dataTables.buttons.min.js")
require("packs/buttons.html5.min.js")

//  for print generate button
require("packs/buttons.print.min.js")
// for pdf generate button
import pdfMake from "pdfmake/build/pdfmake"
import pdfFonts from "pdfmake/build/vfs_fonts"
window.pdfMake = pdfMake;
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import Cropper from 'cropperjs';

require("packs/jquery.ui.touch-punch.min.js");

import LocalTime from "local-time"
import { loadAsync } from "jszip";
LocalTime.start()

window.jQuery = $;
window.$ = $;

// Make ActionCable available globally
window.App = {
  cable: consumer
}; 

$(document).on('turbolinks:load', function() {
  var show_calender="no"
  var myRolldate =new Rolldate({
    el: '#birthdate',
    format: 'MM/DD/YYYY',
    beginYear: 1900,
    endYear: new Date().getFullYear()
  })
  // for auto show visit DOB modal
  $(document).on('click','#nextBtn', function(){
    var first_name= $("#first_name").val()
    var last_name= $("#last_name").val()
    // when first/last name are present and show doesn't show at once
    if(first_name && last_name && show_calender=="no"){
      show_calender="yes"
      myRolldate.show();
    }
  })

})
$(document).on("click",".crop-image", function(){
  $("#preloader").show()
  $.ajax({
    url: '/patients/get_image_to_crop',
    data: {summary_id: $(this).data('summary-id')}
  }).done(function(){
    const im = document.getElementById('croppingImage');
    cropper = new Cropper(im, {
      aspectRatio: 0
    });
  })
})

Rails.start()
Turbolinks.start()
ActiveStorage.start()
